import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
//Nuevo
import apiRoutes from "../../api/apiRoutes";
import { appFetchJson } from "../../utils/http";

import CrearContrato from "../../views/Contratos/Contratos/CrearContrato";
import CrearProductoContrato from "../../views/Contratos/Productos del contrato/CrearProductoContrato";
import CrearContratoTarjeta from "../../views/Contratos/Asignacion de contratos a tarjetas/CrearContratoTarjeta";
//Nuevo
import EditarContrato from "../../views/Contratos/Contratos/EditarContrato";

export default function GestionarContratoModal({
  onClose = () => {},
  onFinish = () => {},
  contratoAEditar = null,
}) {
  const [activeTab, setActiveTab] = useState("contrato");
  const [contratoCreado, setContratoCreado] = useState(contratoAEditar);

  //Nuevo
  const [detalleProducto, setDetalleProducto] = useState(null);
  const [detalleTarjeta, setDetalleTarjeta] = useState(null);

  const tabsEnabled = contratoCreado !== null;

  //Nuevo
  useEffect(() => {
    const cargarDetalles = async () => {
      if (!contratoCreado?.id) {
        setDetalleProducto(null);
        setDetalleTarjeta(null);
        return;
      }
      try {
        // Producto
        const prodRes = await appFetchJson(
          apiRoutes.contratoDetalle.listUrl({
            contratoId: contratoCreado.id,
            size: 1,
          }),
        );
        const prodItems = prodRes?.items || prodRes?.content || [];
        setDetalleProducto(prodItems.length > 0 ? prodItems[0] : null);

        // Tarjeta
        const tarjRes = await appFetchJson(
          apiRoutes.contratoTarjeta.listUrl({
            contratoId: contratoCreado.id,
            size: 1,
          }),
        );
        const tarjItems = tarjRes?.items || tarjRes?.content || [];
        setDetalleTarjeta(tarjItems.length > 0 ? tarjItems[0] : null);
      } catch (e) {
        console.error("Error cargando detalles:", e);
      }
    };
    cargarDetalles();
  }, [contratoCreado]);

  const handleClose = () => {
    if (contratoCreado) {
      onFinish();
    }
    onClose();
  };

  return (
    <div className="modal-backdrop" onClick={handleClose}>
      <div
        className="modal-panel-lg h-[90vh] flex flex-col bg-white rounded-lg shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center shrink-0 border-b px-6 py-4">
          <h2 className="section-title text-xl font-bold text-gray-800">
            Gestión Integral de Contrato
          </h2>
          <button
            className="modal-close-x text-gray-500 hover:text-gray-700"
            onClick={handleClose}
          >
            <FaTimes />
          </button>
        </div>

        {/* TABS */}
        <div className="px-6 pt-4 border-b shrink-0 bg-gray-50 z-10">
          <div className="flex gap-8">
            <button
              type="button"
              className={`pb-3 text-sm font-semibold transition-colors border-b-2 ${
                activeTab === "contrato"
                  ? "border-green-600 text-green-700"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
              onClick={() => setActiveTab("contrato")}
            >
              1. Datos del Contrato
            </button>

            <button
              type="button"
              disabled={!tabsEnabled}
              className={`pb-3 text-sm font-semibold transition-colors border-b-2 ${
                activeTab === "producto"
                  ? "border-green-600 text-green-700"
                  : !tabsEnabled
                    ? "border-transparent text-gray-300 cursor-not-allowed"
                    : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
              onClick={() => tabsEnabled && setActiveTab("producto")}
            >
              2. Asignar Producto
            </button>

            <button
              type="button"
              disabled={!tabsEnabled}
              className={`pb-3 text-sm font-semibold transition-colors border-b-2 ${
                activeTab === "tarjeta"
                  ? "border-green-600 text-green-700"
                  : !tabsEnabled
                    ? "border-transparent text-gray-300 cursor-not-allowed"
                    : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
              onClick={() => tabsEnabled && setActiveTab("tarjeta")}
            >
              3. Asignar Tarjeta
            </button>
          </div>
        </div>

        {/* BODY (Scrollable) */}
        <div className="flex-1 overflow-y-auto bg-white relative">
          {/* PESTAÑA 1: CREAR CONTRATO */}
          {activeTab === "contrato" && (
            <div className="p-8 max-w-4xl mx-auto">
              {contratoAEditar ? (
                <EditarContrato
                  embedded={true}
                  initial={contratoAEditar}
                  onClose={() => {}}
                  onSaved={(actualizado) => {
                    setContratoCreado(actualizado);
                    // Si quieres, al guardar podrías ir a la pestaña de productos
                    // setActiveTab("producto");
                  }}
                />
              ) : (
                <CrearContrato
                  embedded={true}
                  onClose={() => {}}
                  onCreated={(nuevoContrato) => {
                    setContratoCreado(nuevoContrato);
                    setActiveTab("producto");
                  }}
                />
              )}
            </div>
          )}

          {/* PESTAÑA 2: ASIGNAR PRODUCTO */}
          {activeTab === "producto" && (
            <div className="p-8 max-w-4xl mx-auto">
              <div className="mb-4 text-sm text-gray-500">
                Agregando producto al contrato:{" "}
                <strong>{contratoCreado?.codigo}</strong>
              </div>
              <CrearProductoContrato
                embedded={true}
                onClose={() => {}}
                contratoPredefinido={contratoCreado}
                initialData={detalleProducto}
                onCreated={() => {
                  setActiveTab("tarjeta");
                }}
              />
            </div>
          )}

          {/* PESTAÑA 3: ASIGNAR TARJETA */}
          {activeTab === "tarjeta" && (
            <div className="p-8 max-w-4xl mx-auto">
              <div className="mb-4 text-sm text-gray-500">
                Asignando tarjeta al contrato:{" "}
                <strong>{contratoCreado?.codigo}</strong>
              </div>
              <CrearContratoTarjeta
                embedded={true}
                onClose={() => {}}
                contratoPredefinido={contratoCreado}
                initialData={detalleTarjeta}
                onCreated={() => {}}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
